var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImg1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 453,
    height: 329,
    viewBox: "0 0 453 329",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1764_17096)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.6799 324.3C29.6799 324.3 -3.0101 247.3 38.3399 189.17C79.6899 131.04 54.4999 79.4398 127.07 28.1098C220.4 -37.8902 310.41 27.2298 337.25 71.3598C364.09 115.49 455.25 92.9698 428.77 218.56C408.21 315.98 423.55 320.25 423.55 320.25L29.6799 324.3Z",
    fill: "#DEFAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.3898 303.481C49.3898 303.481 -8.61017 273.161 5.38983 205.001C19.3898 136.841 76.2598 120.681 99.6798 125.681C143.57 135.061 71.8598 162.731 54.7298 115.241C33.2398 55.6407 109.87 10.5207 180.91 22.2407C226.56 29.7407 248.6 51.6007 289.18 65.3307C329.76 79.0607 346.58 60.6807 330.5 50.0007C315.2 39.9207 259.68 56.3707 278.74 78.9207C304.85 109.791 367.74 61.9207 416.52 115.221C465.3 168.521 422.95 235.431 385.46 241.021C347.97 246.611 364.41 192.791 422.95 235.431C481.49 278.071 407.5 324.301 407.5 324.301",
    stroke: "#25626F",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.81 328.561H4.27C3.13926 328.561 2.05468 328.113 1.25418 327.314C0.453691 326.515 0.00264811 325.432 0 324.301C0 323.169 0.449874 322.083 1.25065 321.282C2.05143 320.481 3.13753 320.031 4.27 320.031H452.07V324.301C452.07 325.431 451.621 326.515 450.822 327.314C450.023 328.112 448.94 328.561 447.81 328.561Z",
    fill: "#19889F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 320H167.92V324.26C167.92 325.39 167.471 326.473 166.672 327.272C165.873 328.071 164.79 328.52 163.66 328.52H4.26C3.13707 328.52 2.05954 328.077 1.26178 327.286C0.464015 326.496 0.0105439 325.423 0 324.3L0 320Z",
    fill: "#00B4D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.92 157.512C210.92 194.012 189.59 208.882 189.59 208.882L208.02 238.312L240.2 204.862L229.92 157.512Z",
    fill: "#00B4D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.02 148.801L229.92 157.511C226.92 246.611 225.82 320.021 225.82 320.021H310.36C310.36 320.021 312.81 183.581 299.21 153.811L277.02 148.801Z",
    fill: "#00B4D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.55 194.202L294.49 192.262",
    stroke: "#25626F",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.02 175.059C261.02 175.059 275.58 274.429 262.91 314.639",
    stroke: "#003E4C",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.77 224.828C256.139 228.606 267.041 230.719 278.07 231.088C296.31 231.688 284.96 241.398 257.93 239.558",
    stroke: "#003E4C",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.39 145.169L261.01 176.049L277.01 148.799L266.47 131.559L249.39 145.169Z",
    fill: "#8EECFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.01 176.051L282.71 170.061L277.01 148.801L261.01 176.051Z",
    fill: "#19889F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.97 152.031L240.2 165.191L261.01 176.051L251.97 152.031Z",
    fill: "#19889F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.02 238.308C208.02 238.308 214.89 223.968 200.13 205.488C191.94 195.248 188.13 177.578 188.13 177.578L175.82 179.448L187.09 238.308H208.02Z",
    fill: "#8EECFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.35 159.121L168.31 163.701L175.04 169.641L153.96 169.281L153.51 176.521L175.86 179.441L188.16 177.571L173.35 159.121Z",
    fill: "#8EECFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.03 170.389L156.8 162.039L155.5 165.639L172.38 172.729L177.03 170.389Z",
    fill: "#8EECFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.21 153.809C299.21 153.809 326.39 169.279 334.97 227.249L303.44 234.849L299.21 153.809Z",
    fill: "#00B4D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.18 107.44L229.92 133.7L237.77 136.12L240.18 150.91L265.24 145.17L268.86 105.02L240.18 107.44Z",
    fill: "#8EECFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.91 113.681H237.74L239.83 108.021L256.91 106.961V113.681Z",
    fill: "#003E4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.92 125.682C266.92 125.682 254.7 123.152 254.7 110.512C254.7 110.512 236.56 112.982 230.3 103.132C222.88 91.4716 234.21 78.0616 243.57 80.7916C243.57 80.7916 237.68 86.6316 246.63 87.3216C253.02 87.8116 264.7 79.3216 268.87 87.5316C268.87 87.5316 301.02 94.8816 277.02 124.842L266.92 125.682Z",
    fill: "#003E4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.7 109.488C254.7 109.488 230.5 114.168 225.38 96.7781C222.38 86.6181 232.6 80.8281 232.6 80.8281",
    stroke: "#003E4C",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.815 127.312C254.82 122.674 252.686 117.288 248.047 115.283C243.409 113.277 238.023 115.412 236.018 120.051C234.012 124.689 236.147 130.075 240.785 132.08C245.424 134.086 250.81 131.951 252.815 127.312Z",
    stroke: "#003E4C",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.09 120.75L266.13 121.46",
    stroke: "#003E4C",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.71 127.971C282.71 133.641 275.12 138.231 269.45 138.231C263.78 138.231 262.19 133.641 262.19 127.971C262.19 126.624 262.455 125.289 262.971 124.045C263.487 122.8 264.242 121.669 265.195 120.716C266.148 119.763 267.279 119.008 268.524 118.492C269.768 117.976 271.103 117.711 272.45 117.711C273.797 117.711 275.131 117.976 276.376 118.492C277.621 119.008 278.752 119.763 279.705 120.716C280.658 121.669 281.413 122.8 281.929 124.045C282.445 125.289 282.71 126.624 282.71 127.971Z",
    fill: "#8EECFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.2 228.148V275.478H307.6L305.64 234.318L331.2 228.148Z",
    fill: "#8EECFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.08 217.449L229.07 184.469L213.78 232.309L228.08 217.449Z",
    fill: "#25626F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.61 148.312L265.24 145.172L253.24 155.412L250.61 148.312Z",
    fill: "#003E4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.71 124.31C243.71 126.31 242.92 127.97 241.95 127.97C240.98 127.97 240.2 126.33 240.2 124.31C240.2 122.29 240.99 120.66 241.95 120.66C242.91 120.66 243.71 122.29 243.71 124.31Z",
    fill: "#003E4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.71 115.429C246.71 110.529 242.81 113.829 242.81 113.829L246.71 115.429Z",
    fill: "#003E4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.81 137.101L248.39 135.621C248.39 135.621 250.78 156.301 242.81 137.101Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.68 229.788C122.68 229.788 160.29 223.968 161.03 289.558C161.15 300.198 167.92 320.028 167.92 320.028H133.84L122.68 229.788Z",
    fill: "#25626F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.3499 223.969L60.6099 229.329L67.5499 320.029H156C156 320.029 153 248.269 119.68 226.739L83.3499 223.969Z",
    fill: "#19889F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.6101 229.329C37.1801 234.679 42.6701 252.679 47.1901 289.589C35.5001 299.089 46.7201 303.359 46.7201 303.359C33.8701 316.979 49.8901 320.029 49.8901 320.029H92.6701C92.6701 320.029 84.0601 223.979 60.6101 229.329Z",
    fill: "#19889F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.1199 299.081L79.8599 251.961",
    stroke: "#022C35",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.8901 320.031C49.8901 320.031 57.1201 303.451 79.9401 295.121C98.8701 288.211 126.55 306.121 144.27 289.121L147.55 308.311L92.6701 320.051L49.8901 320.031Z",
    fill: "#8EECFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.13 177.248L142.06 203.008L131.2 206.878L129.32 227.818L96.6899 216.478L99.7599 173.898L125.13 177.248Z",
    fill: "#8EECFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.02 204.309L83.3398 223.959L104.73 250.179L114.38 219.559L100.02 204.309Z",
    fill: "#19889F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.6 192.14L129.47 183.85L125.13 177.25L101.55 179.7L105.6 192.14Z",
    fill: "#19889F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.5 201.161C103.5 201.161 110.73 215.631 105.7 187.741C105.7 187.741 112.56 188.511 117.93 179.461C117.93 179.461 116.26 194.211 132.02 179.461C147.78 164.711 127.74 153.171 103.27 157.511C82.0598 161.271 60.8298 173.261 91.8498 213.891L103.5 201.161Z",
    fill: "#003E4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.6798 206.911C97.9006 209.309 95.2834 210.948 92.3498 211.501C86.5298 212.351 80.8498 207.761 79.9998 201.941C79.1498 196.121 82.0898 193.111 87.9098 192.261C91.391 191.839 94.907 192.699 97.7998 194.681C98.6598 195.791 99.6798 206.911 99.6798 206.911Z",
    fill: "#8EECFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.31 194.842C123.85 196.842 123.58 198.632 122.71 198.842C121.84 199.052 120.71 197.652 120.16 195.672C119.61 193.692 119.88 191.872 120.76 191.672C121.64 191.472 122.77 192.852 123.31 194.842Z",
    fill: "#003E4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.09 190.219C116.09 190.219 115.24 185.439 119.68 187.739L116.09 190.219Z",
    fill: "#003E4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.6699 224.771L84.5499 220.321L83.1199 217.021L91.8899 213.891L117.04 226.541L117.97 236.201L113.71 234.851L106.76 260.751L80.6699 224.771Z",
    fill: "#25626F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.38 231.089L117.97 236.199L117.04 226.539",
    stroke: "#022C35",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.74 187.738C105.74 187.738 108.68 204.808 112.97 208.328C114.38 209.478 117.04 206.548 129.32 206.328C136.83 206.178 136.82 232.378 126.86 231.628C116.9 230.878 101.76 224.628 99.4897 205.568C97.4997 188.788 105.74 187.738 105.74 187.738Z",
    fill: "#003E4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.97 211.5C117.97 211.5 120.5 216.22 125.49 213.02",
    stroke: "#C4C6C5",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.9302 309.249H174.93C176.14 309.249 177.299 309.729 178.155 310.584C179.01 311.44 179.49 312.599 179.49 313.809V315.469C179.486 316.068 179.364 316.66 179.132 317.212C178.899 317.763 178.56 318.264 178.133 318.684C177.707 319.105 177.202 319.438 176.648 319.663C176.093 319.889 175.499 320.003 174.9 319.999H95.4902C94.2808 319.999 93.1209 319.518 92.2658 318.663C91.4106 317.808 90.9302 316.648 90.9302 315.439V309.219V309.249Z",
    fill: "#00B4D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.1 246.879H145.42C144.023 246.879 142.673 247.385 141.621 248.305C140.569 249.224 139.887 250.494 139.7 251.879L131.83 313.499C131.728 314.311 131.8 315.135 132.041 315.917C132.281 316.699 132.686 317.42 133.226 318.034C133.767 318.648 134.433 319.139 135.178 319.477C135.924 319.814 136.732 319.988 137.55 319.989H235.23C236.628 319.991 237.979 319.486 239.031 318.566C240.084 317.646 240.766 316.374 240.95 314.989L248.82 253.369C248.922 252.557 248.851 251.733 248.61 250.951C248.369 250.169 247.965 249.448 247.424 248.834C246.883 248.22 246.218 247.728 245.472 247.391C244.727 247.054 243.918 246.88 243.1 246.879Z",
    fill: "#00B4D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.82 246.879H150.15C148.753 246.879 147.403 247.385 146.351 248.305C145.299 249.224 144.617 250.494 144.43 251.879L136.56 313.499C136.456 314.311 136.527 315.136 136.767 315.918C137.007 316.701 137.411 317.423 137.952 318.037C138.494 318.652 139.16 319.143 139.906 319.48C140.652 319.816 141.462 319.99 142.28 319.989H239.96C241.358 319.991 242.709 319.486 243.761 318.566C244.814 317.646 245.496 316.374 245.68 314.989L253.55 253.369C253.651 252.557 253.578 251.732 253.336 250.95C253.094 250.169 252.688 249.447 252.147 248.833C251.605 248.22 250.939 247.728 250.193 247.391C249.448 247.054 248.639 246.88 247.82 246.879Z",
    fill: "#19889F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.69 283.46C204.363 286.075 203.107 288.485 201.153 290.252C199.198 292.02 196.674 293.027 194.04 293.09C192.812 293.117 191.594 292.877 190.467 292.388C189.341 291.9 188.334 291.173 187.515 290.258C186.696 289.343 186.085 288.262 185.723 287.088C185.362 285.915 185.258 284.677 185.42 283.46C185.747 280.847 187.001 278.438 188.953 276.671C190.906 274.904 193.427 273.896 196.06 273.83C197.288 273.804 198.507 274.043 199.634 274.532C200.76 275.021 201.768 275.747 202.588 276.662C203.408 277.577 204.02 278.658 204.383 279.831C204.745 281.004 204.85 282.242 204.69 283.46Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.69 319.512H124.11",
    stroke: "#00B4D8",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.43 237.059L339.79 237.819L330.64 188.449L309.18 190.879C309.18 190.879 299.51 205.149 307.18 216.239C315.76 228.759 298.5 229.229 299.43 237.059Z",
    fill: "#003E4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.18 190.879C309.18 190.879 299.51 205.149 307.18 216.239C315.8 228.759 298.58 229.239 299.47 237.059",
    stroke: "#25626F",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.23 231.09C317.23 231.09 298.86 249.09 289.18 317.02H309.62L317.23 231.09Z",
    fill: "#25626F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.76 226.069L357.76 317.019H298.4L305.79 282.289C305.79 282.289 283.18 270.489 317.23 231.089L325.69 226.739L362.5 223.969L365.76 226.069Z",
    fill: "#8EECFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.23 271.801C317.23 271.801 313.67 277.891 317.09 282.801L312.09 317.031",
    stroke: "#25626F",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.93 282.441L343.31 283.461",
    stroke: "#25626F",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.09 299.56L346.46 255.82",
    stroke: "#25626F",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.76 226.07C365.76 226.07 369.04 230.2 372.84 239.76C378.22 253.33 384.64 277.83 384.22 317.02H357.77L365.76 226.07Z",
    fill: "#8EECFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.22 320.021C384.22 320.021 371 289.801 337.77 298.451C301.47 307.891 288 306.131 288 306.131L285.25 320.021H384.22Z",
    fill: "#8EECFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.62 292.102L337.83 294.742L364.62 320.022H389.87C389.87 320.022 378.98 293.682 349.62 292.102Z",
    fill: "#25626F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288 306.129L270.75 302.559L258.39 320.019H285.24L288 306.129Z",
    fill: "#8EECFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.22 271.802L349.27 239.752L343.31 236.942L365.76 226.072L355.45 219.512H331.47L317.22 237.322L321.16 238.312L317.22 241.062V271.802Z",
    fill: "#25626F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.63 230.41L350.09 223.17L338.8 197.91L321.28 208.91L326.21 229.87L317.22 271.8L339.63 230.41Z",
    fill: "#8EECFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.69 214.89L334.98 208.48L324.01 220.49L322.69 214.89Z",
    fill: "#25626F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.23 178.309L294.87 208.059H302.92L311.96 220.489L334.98 208.479L318.88 172.609L300.23 178.309Z",
    fill: "#8EECFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.93 185.528L298.39 188.788L319.63 185.898L319.3 181.828L298.93 185.528Z",
    fill: "#25626F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.92 176.061C353.61 161.651 347.11 156.061 347.11 156.061C334.11 143.121 311.82 157.481 311.82 157.481C283.29 150.571 294.87 186.001 294.87 186.001L318.11 183.151C321.35 202.641 332.97 192.771 332.97 192.771L338.39 202.541C338.39 202.541 332.93 207.371 338.62 215.661C343.32 222.481 332.08 224.801 334.98 232.061L379.9 222.751C379.9 193.231 368.5 202.101 358.92 176.061Z",
    fill: "#003E4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.05 186.26C293.05 186.26 288.94 166.03 296.49 159.45C300.42 156.02 312.82 157.51 312.82 157.51",
    stroke: "#25626F",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.84 221.94C382.84 221.94 386.42 208.49 366.84 193.23",
    stroke: "#003E4C",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.078 196.39C344.301 191.186 341.074 185.976 335.87 184.752C330.666 183.528 325.455 186.755 324.231 191.96C323.008 197.164 326.235 202.375 331.439 203.598C336.643 204.822 341.854 201.595 343.078 196.39Z",
    fill: "#8EECFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.93 206.968L314.93 205.488C314.93 205.488 317.03 222.598 308.93 206.968Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.93 196.861C303.93 196.861 305.84 185.221 310.02 196.861",
    stroke: "#00B4D8",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.41 188.009C305.41 188.009 307.73 184.069 310.49 188.009H305.41Z",
    fill: "#003E4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.15 83.1882C214.166 80.4512 212.531 77.9946 210.386 76.0304C208.241 74.0662 205.65 72.6533 202.837 71.9137C200.024 71.174 197.073 71.1298 194.239 71.7848C191.406 72.4398 188.774 73.7743 186.571 75.6733C184.368 77.5723 182.66 79.9787 181.594 82.6851C180.528 85.3914 180.137 88.3163 180.454 91.2075C180.771 94.0988 181.786 96.8695 183.413 99.2808C185.039 101.692 187.228 103.671 189.79 105.048C193.528 107.044 196.719 109.929 199.08 113.448L199.76 114.448L213.19 109.678L213.07 108.468C212.673 104.18 213.321 99.8604 214.96 95.8782C216.579 91.8151 216.647 87.298 215.15 83.1882Z",
    fill: "#C3C8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.15 83.1882C214.166 80.4512 212.531 77.9946 210.386 76.0304C208.241 74.0662 205.65 72.6533 202.837 71.9137C200.024 71.174 197.073 71.1298 194.239 71.7848C191.406 72.4398 188.774 73.7743 186.571 75.6733C184.368 77.5723 182.66 79.9787 181.594 82.6851C180.528 85.3914 180.137 88.3163 180.454 91.2075C180.771 94.0988 181.786 96.8695 183.413 99.2808C185.039 101.692 187.228 103.671 189.79 105.048C193.528 107.044 196.719 109.929 199.08 113.448L199.76 114.448L213.19 109.678L213.07 108.468C212.673 104.18 213.321 99.8604 214.96 95.8782C216.579 91.8151 216.647 87.298 215.15 83.1882Z",
    fill: "#BFF4FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.83 110.51L192.12 95.3995C192.146 94.9804 192.265 94.5722 192.467 94.2045C192.67 93.8367 192.952 93.5184 193.292 93.2726C193.633 93.0268 194.024 92.8596 194.436 92.783C194.849 92.7064 195.274 92.7223 195.68 92.8295C199.04 93.3095 201.05 98.6195 198.68 97.7595C196.31 96.8995 195.43 90.6695 199.97 89.7595C204.51 88.8495 206.02 99.1195 203.52 97.1295C201.02 95.1395 201.52 88.5795 206.4 88.5195L209.25 110.31",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.43 107.54L202.126 109.808C199.725 110.671 198.478 113.317 199.342 115.719L200.675 119.426C201.539 121.827 204.185 123.073 206.586 122.21L212.891 119.943C215.292 119.079 216.538 116.433 215.675 114.032L214.341 110.324C213.478 107.923 210.831 106.677 208.43 107.54Z",
    fill: "#003E4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.374 104.179L195.375 111.012L198.712 120.29L217.71 113.457L214.374 104.179Z",
    fill: "#8EECFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.82 66.7411L195.92 55.8711",
    stroke: "#C3C8FF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.12 73.2098L175.05 64.3398",
    stroke: "#C3C8FF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.66 89.3203L164.31 90.0603",
    stroke: "#C3C8FF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.75 72.6908L217.41 64.0508",
    stroke: "#C3C8FF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.59 152.54H422.82C423.948 152.499 425.03 152.084 425.896 151.36C426.761 150.635 427.361 149.643 427.6 148.54L434.23 111.92C434.343 111.431 434.341 110.922 434.225 110.434C434.109 109.945 433.883 109.49 433.562 109.103C433.242 108.716 432.838 108.409 432.379 108.203C431.921 107.998 431.422 107.901 430.92 107.92H366.7C365.571 107.958 364.487 108.372 363.621 109.097C362.755 109.822 362.156 110.816 361.92 111.92L355.28 148.54C355.17 149.029 355.173 149.537 355.29 150.025C355.406 150.513 355.633 150.967 355.953 151.353C356.272 151.74 356.676 152.047 357.134 152.253C357.591 152.459 358.089 152.557 358.59 152.54Z",
    fill: "#19889F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.32 130.191C403.196 130.701 403.192 131.233 403.308 131.746C403.424 132.258 403.658 132.737 403.99 133.143C404.323 133.55 404.745 133.875 405.223 134.091C405.702 134.308 406.225 134.41 406.75 134.391C407.934 134.354 409.071 133.92 409.979 133.158C410.886 132.396 411.51 131.351 411.75 130.191C411.872 129.679 411.874 129.147 411.756 128.635C411.639 128.122 411.404 127.644 411.071 127.238C410.738 126.831 410.315 126.507 409.836 126.29C409.357 126.074 408.835 125.972 408.31 125.991C407.127 126.027 405.991 126.462 405.085 127.224C404.18 127.986 403.558 129.031 403.32 130.191Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.56 130.191C390.438 130.702 390.436 131.234 390.553 131.746C390.671 132.259 390.906 132.737 391.239 133.143C391.572 133.55 391.994 133.874 392.473 134.091C392.952 134.307 393.475 134.41 394 134.391C395.185 134.356 396.323 133.923 397.231 133.16C398.138 132.398 398.762 131.352 399 130.191C399.122 129.679 399.125 129.147 399.007 128.635C398.889 128.122 398.655 127.644 398.321 127.238C397.988 126.831 397.566 126.507 397.087 126.29C396.608 126.074 396.085 125.972 395.56 125.991C394.375 126.025 393.237 126.458 392.329 127.221C391.422 127.983 390.798 129.029 390.56 130.191Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.591 133.033C386.466 131.319 386.827 128.661 385.397 127.095C383.967 125.529 381.287 125.649 379.411 127.362C377.535 129.076 377.174 131.734 378.604 133.3C380.035 134.866 382.715 134.746 384.591 133.033Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.16 150.13L370.84 163.4L374.84 149.09L393.16 150.13Z",
    fill: "#19889F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.68 147.11H87.5002C86.373 147.07 85.2915 146.655 84.4273 145.93C83.5631 145.206 82.9658 144.213 82.7302 143.11L76.0902 106.49C75.9798 106.001 75.9831 105.493 76.0997 105.006C76.2163 104.518 76.4431 104.063 76.7628 103.677C77.0824 103.291 77.4864 102.983 77.9436 102.777C78.4008 102.571 78.8991 102.473 79.4002 102.49H143.63C144.758 102.531 145.84 102.947 146.706 103.671C147.571 104.395 148.171 105.387 148.41 106.49L155.04 143.11C155.152 143.603 155.148 144.116 155.029 144.608C154.909 145.099 154.678 145.556 154.353 145.944C154.027 146.331 153.617 146.638 153.153 146.84C152.69 147.043 152.185 147.135 151.68 147.11Z",
    fill: "#8EECFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.96 124.761C107.082 125.272 107.084 125.805 106.967 126.317C106.849 126.829 106.614 127.307 106.281 127.714C105.948 128.12 105.526 128.445 105.047 128.661C104.568 128.877 104.045 128.98 103.52 128.961C102.335 128.926 101.197 128.493 100.289 127.731C99.3819 126.968 98.7584 125.922 98.5201 124.761C98.3979 124.25 98.3957 123.717 98.5134 123.205C98.6311 122.693 98.8656 122.214 99.1987 121.808C99.5317 121.401 99.9542 121.077 100.433 120.861C100.912 120.644 101.435 120.542 101.96 120.561C103.145 120.595 104.283 121.029 105.191 121.791C106.098 122.553 106.722 123.6 106.96 124.761Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.912 127.854C120.342 126.288 119.981 123.63 118.105 121.916C116.23 120.203 113.549 120.083 112.119 121.649C110.689 123.215 111.05 125.873 112.926 127.587C114.801 129.3 117.482 129.42 118.912 127.854Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.5 124.761C132.622 125.272 132.624 125.805 132.507 126.317C132.389 126.829 132.155 127.307 131.821 127.714C131.488 128.12 131.066 128.445 130.587 128.661C130.108 128.877 129.585 128.98 129.06 128.961C127.876 128.925 126.738 128.491 125.831 127.729C124.924 126.967 124.3 125.921 124.06 124.761C123.938 124.25 123.936 123.717 124.053 123.205C124.171 122.693 124.406 122.214 124.739 121.808C125.072 121.401 125.494 121.077 125.973 120.861C126.452 120.644 126.975 120.542 127.5 120.561C128.685 120.595 129.823 121.029 130.731 121.791C131.638 122.553 132.262 123.6 132.5 124.761Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.77 144.709L132.29 157.509L146.54 143.809L128.77 144.709Z",
    fill: "#8EECFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1764_17096"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 452.07,
    height: 328.56,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg1);
export default __webpack_public_path__ + "static/media/img1.c2ee185f6042bdc93888b607ea421b56.svg";
export { ForwardRef as ReactComponent };